import * as Tooltip from './Tooltip.css';
export default { Tooltip: Tooltip };
